// ============================================================
// useSessionTracker — Hook per gestire lo span radice della
// sessione utente.
//
// Deve essere chiamato UNA SOLA VOLTA, nel componente App: ogni
// chiamata riavvia la sessione (nuovo traceId/sessionId) e
// scollega dal journey tutto quello che segue. Crea lo span
// radice 'session' che fa da parent per tutti gli span pagina
// generati da useComponentMetric, e lo chiude insieme alla pagina
// corrente quando la tab viene chiusa (pagehide).
//
// Uso: const { trackLandingEvent } = useSessionTracker();
//      trackLandingEvent(); // all'atterraggio
//
// Nelle pagine (es. thank-you) usare direttamente trackCreateAppointment,
// trackSpanCreateAppointment e trackSpanSessionEnd da otelExporter.
// ============================================================

import { useEffect, useRef, useCallback } from "react";
import { trackSpanSessionStart, trackSpanSessionEnd, trackPageHide, trackLanding } from "./otelExporter";

export default function useSessionTracker() {
    const startedRef = useRef(false);

    // All mount: avvia lo span radice di sessione
    useEffect(() => {
        if (!startedRef.current) {
            startedRef.current = true;
            trackSpanSessionStart();
        }

        window.addEventListener("pagehide", trackPageHide);

        return () => {
            window.removeEventListener("pagehide", trackPageHide);
            // Cleanup: chiudi sessione se ancora aperta
            trackSpanSessionEnd();
            startedRef.current = false;
        };
    }, []);

    const trackLandingEvent = useCallback(() => {
        trackLanding();
    }, []);

    return { trackLandingEvent };
}
